// Utils
import createDeepEqualSelector from '../../utils/reselect/createDeepEqualSelector';

// Types
import type { TimesheetEntry } from '../timesheetEntries/types';

type State = {
    timesheetTimesheetEntries: {
        [string]: TimesheetEntry
    }
};

const selectTimesheetTimesheetEntries = (state: State) =>
    state.timesheetTimesheetEntries;

const selectTimesheetTimesheetEntriesArray = createDeepEqualSelector(
    selectTimesheetTimesheetEntries,
    timesheetTimesheetEntriesState =>
        Object.values(timesheetTimesheetEntriesState)
);

export {
    selectTimesheetTimesheetEntries,
    selectTimesheetTimesheetEntriesArray
};
